import { PropsWithChildren } from 'react';
import './sideDrawer.scss';

enum DrawerDirection {
  Left = 'Left',
  Right = 'Right',
}

const CloseIcon: React.FC = () => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M18 6L6 18'
      stroke='#2F3437'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M6 6L18 18'
      stroke='#2F3437'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

type Props = {
  title: string;
  isOpen: boolean;
  direction?: DrawerDirection;
  onClose: () => void;
} & PropsWithChildren;

const SideDrawer = ({
  title,
  isOpen,
  children,
  direction = DrawerDirection.Right,
  onClose,
}: Props) => {
  const classNames = `drawer ${[direction]} ${isOpen ? 'open' : ''}`;

  return (
    <div className={classNames}>
      <div className='d-flex flex-row justify-content-between px-3 border-bottom p-2 drawer-header'>
        <span className='drawer-title'>{title}</span>
        <span className='close' onClick={onClose}>
          <CloseIcon />
        </span>
      </div>
      <div className={'container-fluid p-4'}>{children}</div>
    </div>
  );
};

export default SideDrawer;
